import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadRandomVehicles } from '@states/vehicle/vehicle.actions';
import { catchError, of } from 'rxjs';
import { map, take, timeout } from 'rxjs/operators';

/**
 * Loads the home page's featured vehicles into the store before the route
 * renders, so the "Featured motorhomes" cards land in the prerendered HTML
 * and give crawlers real /motorhome/ links from the home page (HMM-162 IL-2).
 *
 * The Router awaits resolvers, so the dispatch is settled deterministically
 * under prerender — dispatching from the component constructor instead was
 * fire-and-forget and raced the SSR stability snapshot, leaving the carousel
 * stuck on its loading skeleton.
 */
export const homeVehiclesResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.dispatch(new LoadRandomVehicles(8)).pipe(
    take(1),
    timeout(5000), // Don't hang the render if Firestore is slow/unreachable.
    map(() => true),
    catchError(() => of(true)),
  );
};
